const ANWAELTE = 'anwaelte';
const KANZLEIEN = 'kanzleien';
const PRACTICE_AREA_QUERY = ['fachanwaltschaften', 'rechtsgebiete'];
const LOCATION_QUERY = 'wo=';
const HOSTNAME = 'www.anwalt.de';
const DIRECT_MESSAGE = '/nachricht-verfassen?source=';

export { ANWAELTE, KANZLEIEN, PRACTICE_AREA_QUERY, LOCATION_QUERY, HOSTNAME, DIRECT_MESSAGE };
